'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-929adab5.js');
var React = require('react');
var styled = require('styled-components');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var generateHorizontalStyle = function (_a) {
    var horizontalAlignment = _a.horizontalAlignment;
    switch (horizontalAlignment) {
        case constants_properties.MenuHorizontalAlignment.RIGHT:
            return 'right: 0;';
        case constants_properties.MenuHorizontalAlignment.LEFT:
        default:
            return 'left: 0;';
    }
};
var Container = styled__default["default"].ul(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  z-index: 999;\n  margin: 0;\n  padding: 5px 0 0;\n  list-style: none;\n  box-shadow: ", ";\n  border-radius: 7px;\n  position: absolute;\n  top: 100%;\n  ", ";\n  display: ", ";\n  background-color: ", ";\n"], ["\n  z-index: 999;\n  margin: 0;\n  padding: 5px 0 0;\n  list-style: none;\n  box-shadow: ", ";\n  border-radius: 7px;\n  position: absolute;\n  top: 100%;\n  ", ";\n  display: ", ";\n  background-color: ", ";\n"])), function (_a) {
    var shadows = _a.theme.shadows;
    return shadows[2];
}, function (_a) {
    var horizontalAlignment = _a.horizontalAlignment;
    return generateHorizontalStyle({ horizontalAlignment: horizontalAlignment });
}, function (props) { return (props.isVisible ? 'block' : 'none'); }, function (_a) {
    var primary = _a.theme.colors.background.primary;
    return primary;
});
var CLICK_EVENT_TYPES = ['mouse', 'touch'];
var Menu = function (_a) {
    var open = _a.open, onClose = _a.onClose, children = _a.children, _b = _a.horizontalAlignment, horizontalAlignment = _b === void 0 ? constants_properties.MenuHorizontalAlignment.LEFT : _b, className = _a.className, id = _a.id, rest = tslib_es6.__rest(_a, ["open", "onClose", "children", "horizontalAlignment", "className", "id"]) // TODO: this is for aria-* props, find a better way to do this with predefined type that comes from React
    ;
    var menu_ref = React.useRef(null);
    var handleClickOutside = function (event) {
        if (menu_ref.current &&
            !menu_ref.current.contains(event.target) &&
            CLICK_EVENT_TYPES.includes(event.pointerType)) {
            onClose();
        }
    };
    var handleBlur = function (event) {
        if (open &&
            menu_ref.current &&
            !menu_ref.current.contains(event.target)) {
            onClose();
        }
    };
    var focusOnController = function () {
        var props = rest;
        var controller_id = props['aria-labelledby'];
        if (controller_id) {
            var element = document.querySelector("#".concat(controller_id));
            element.focus();
        }
    };
    var handleKeyPress = function (event) {
        if (event.key === 'Escape') {
            event.stopPropagation();
            onClose();
            focusOnController();
        }
    };
    React.useEffect(function () {
        document.addEventListener('click', handleClickOutside, true);
        document.addEventListener('focus', handleBlur, true);
        return function () {
            document.removeEventListener('click', handleClickOutside, true);
            document.removeEventListener('focus', handleBlur, true);
        };
    });
    return (React__default["default"].createElement(Container, tslib_es6.__assign({ role: "menu", id: id, ref: menu_ref, className: className, isVisible: open, horizontalAlignment: horizontalAlignment, onKeyDown: handleKeyPress, onClick: function (e) {
            e.stopPropagation();
            onClose();
        } }, rest), children));
};
var templateObject_1;

exports["default"] = Menu;
